/** @file Mixing class of a Sample.values channel: angle, additive, scale, absolute or discrete (W2-06). */
import { POSE_LAYOUT as L } from '../contracts/pose';

/** 0 angle (rotation), 1 additive (x, y, shear), 2 scale, 3 absolute (slot colour, IK mix/softness), 4 discrete (IK flags). */
export type ChannelClass = 0 | 1 | 2 | 3 | 4;

/** Class of Sample.values channel c, given where the slot and IK blocks start (allocation-free). */
export function channelClass(c: number, slotStart: number, ikStart: number): ChannelClass {
  if (c >= ikStart) {
    const k = (c - ikStart) % L.IK_STRIDE;
    return k === L.IK_MIX || k === L.IK_SOFTNESS ? 3 : 4;
  }
  if (c >= slotStart) return 3;
  const k = c % L.LOCAL_STRIDE;
  if (k === L.ROTATION) return 0;
  return k === L.SCALE_X || k === L.SCALE_Y ? 2 : 1;
}
